import uniq from "lodash/uniq"

const regionOverrides = {
    "pt-BR": "br",
}

export function getBrowserPreferredLocales(
    languages = [
        window.navigator.language,
        ...Array.from(window.navigator.languages || []),
    ]
) {
    const locales = []

    for (const lang of languages) {
        if (typeof lang !== "string" || !lang.trim()) continue

        const subtags = lang.trim().split("-")
        const primary = subtags[0]
        const baseTag =
            subtags.length >= 2 ? `${subtags[0]}-${subtags[1]}` : lang

        if (baseTag in regionOverrides) {
            locales.push(regionOverrides[baseTag])
            if (/^\w{2}$/.test(primary)) locales.push(primary)
        } else if (/^\w{2}$/.test(primary)) {
            locales.push(primary)
        }
    }

    return uniq(locales)
}
